// ===============================
// TrameMensuelleGarde.jsx
// ===============================
// Affiche le planning complet mensuel des gardes validées.
// ===============================

import React, { useEffect, useState } from "react";
import { fetchListeGardesValidee, formatMedecinGarde } from "./gardesV2.js";

export default function TrameMensuelleGarde({ mois = "2026-02", typeGarde = "PR2" }) {
  const [planning, setPlanning] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estValidee, setEstValidee] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError(null);
    fetchListeGardesValidee({ mois, typeGarde })
      .then(({ estValidee: listeEstValidee, lignes }) => {
        if (cancelled) return;
        setEstValidee(listeEstValidee);
        setPlanning(lignes);
      })
      .catch((err) => {
        if (cancelled) return;
        setEstValidee(false);
        setPlanning([]);
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [mois, typeGarde]);

  const S = {
    container: {
      maxWidth: "1000px",
      margin: "40px auto",
      padding: "20px",
      fontFamily:
        "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    title: {
      textAlign: "center",
      fontSize: "32px",
      fontWeight: "700",
      marginBottom: "20px",
    },
    tableWrap: {
      overflowX: "auto",
      background: "#fff",
      border: "1px solid #e5e7eb",
      borderRadius: "10px",
      boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "15px",
    },
    th: {
      background: "#f3f4f6",
      border: "1px solid #e5e7eb",
      padding: "8px",
      fontWeight: "700",
      textAlign: "center",
    },
    td: {
      border: "1px solid #f1f5f9",
      padding: "8px 10px",
      textAlign: "center",
    },
  };

  if (error) return <div style={{ color: "red", textAlign: "center" }}>❌ {error}</div>;
  if (loading) return <div style={{ textAlign: "center" }}>⏳ Chargement du planning...</div>;
  if (!estValidee || planning.length === 0) {
    return (
      <div style={{ color: "red", textAlign: "center" }}>
        ⚠️ La trame mensuelle {typeGarde} {mois} n’a pas encore été validée.
      </div>
    );
  }

  return (
    <div style={S.container}>
      <h1 style={S.title}>📅 Planning des gardes – {typeGarde} – {mois}</h1>

      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Date</th>
              <th style={S.th}>Jour</th>
              <th style={S.th}>Médecin de garde</th>
            </tr>
          </thead>
          <tbody>
            {planning.map(({ date, medecin }) => {
              const d = new Date(date);
              const jour = d.toLocaleDateString("fr-FR", { weekday: "long" });
              return (
                <tr key={date}>
                  <td style={S.td}>{date}</td>
                  <td style={S.td}>{jour}</td>
                  <td style={S.td}>{formatMedecinGarde(medecin)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
